import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useSaveRegisterActivityNews = (userId, newsId) => {
  const mutation = useMutation((formData) => {
    const body = formData || {}; 
    return axiosClient.post(`NewsAndPromotions/RegisterClickUser?userId=${userId}&newsAndPromotionId=${newsId}`, body);
  });
  return mutation;
};

//SI SE REQUIERE RECIBIR PARAMS
/* const useSaveRegisterActivityNews = () => {
  return useMutation(({ body = {}, params = {} }) => {
    return axiosClient.post(
      `NewsAndPromotions/RegisterClickUser`, 
      body, 
      { params } 
    );
  });
}; */

export default useSaveRegisterActivityNews;
